import { addEmptyInterval } from 'console/schedule-editor/transform-schedule';
import { changeIntervals } from 'console/schedule-editor/time-line/transform';
export function interimIntervalChanges(intervals, selected_id, changes) {
    const new_intervals = changeIntervals(intervals, selected_id, changes);
    return addEmptyInterval(new_intervals, selected_id);
}
